/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Sponsor_To_Register_TitleInputs */



/**
* | output |
* | --- |
* | "Sponsor & Register" |
*
* @param {Vekn_Sponsor_To_Register_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_sponsor_to_register_title = /** @type {((inputs?: Vekn_Sponsor_To_Register_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Sponsor_To_Register_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parrainer & Inscrire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Patrocinar e Inscribir")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Patrocinar & Inscrever")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sponsorizza & Iscriviti")
	return /** @type {LocalizedString} */ ("Sponsor & Register")
});